import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import '@/asset/config/country';
import { I18n } from '@/asset/js/i18n';
import store from '@/store';
import '@/asset/styles/index.less';
import '@/asset/js/axiosConfig';
import OyaApp from './App';

// oya.souluapp.com 独立入口；线上需将默认页指向 oya.html，SPA fallback 到 oya.html
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <I18n component={OyaApp} />
    </BrowserRouter>
  </Provider>
);
